import React from "react";
import { useParams, Link } from "react-router-dom";
import styled from "styled-components";
import { blogPosts } from "../utils/blogPosts";
import Navigation from "../../navigation/header";
import Footer from "../../Footer/footer";

// Import your blog components
import Blog1 from "./blog1";
import Blog2 from "./blog2";
import Blog3 from "./blog3";
import Blog4 from "./blog4";
import Blog5 from "./blog5";
import Blog6 from "./blog6";
import Blog7 from "./blog7";
import Blog8 from "./blog8";
import Blog9 from "./blog9";
import Blog10 from "./blog10";
import Blog11 from "./blog11";
import Blog12 from "./blog12";
import Blog13 from "./blog13";
import Blog14 from "./blog14";
import Blog15 from "./blog15";
import Blog16 from "./blog16";
import Blog17 from "./blog17";
import Blog18 from "./blog18";
import Blog19 from "./blog19";
import Blog20 from "./blog20";
import Blog21 from "./blog21";
import Blog22 from "./blog22";
import Blog23 from "./blog23";
import Blog24 from "./blog24";
import BackButton from "../utils/back_button";

// Map blogId → component
const blogComponents = {
  1: Blog1,
  2: Blog2,
  3: Blog3,
  4: Blog4,
  5: Blog5,
  6: Blog6,
  7: Blog7,
  8: Blog8,
  9: Blog9,
  10: Blog10,
  11: Blog11,
  12: Blog12,
  13: Blog13,
  14: Blog14,
  15: Blog15,
  16: Blog16,
  17: Blog17,
  18: Blog18,
  19: Blog19,
  20: Blog20,
  21: Blog21,
  22: Blog22,
  23: Blog23,
  24: Blog24,
};

const BlogView = () => {
  const { type, blogId } = useParams();

  // Validate blog existence
  const blog = blogPosts.find((b) => b.type === type && b.blogId === blogId);
  const BlogComponent = blogComponents[blogId];

  if (!blog || !BlogComponent) {
    return (
      <>
        {/* <Navigation /> */}
        <NotFoundWrap>
          <h2>Blog not found</h2>
          <BackButton />
        </NotFoundWrap>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navigation />
      <BlogComponent />
      <Footer />
    </>
  );
};

export default BlogView;

//
// ======= Styled Components =======
//
const NotFoundWrap = styled.div`
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  h2 {
    font-size: 1.8rem;
    color: #333;
    margin-bottom: 16px;
  }
`;

const BackLink = styled(Link)`
  color: #6a37e3;
  font-weight: 600;
  text-decoration: none;
  border: 1px solid #6a37e3;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    background: #6a37e3;
    color: #fff;
  }
`;
